import { useEffect, useRef } from 'react';
import { FaGlassCheers, FaGift, FaMapMarkerAlt, FaComment, FaBroadcastTower } from 'react-icons/fa';
import InteractiveSelector from '@/components/ui/interactive-selector';
import { appScreenshots } from '@/mocks/homeData';

const options = [
  {
    title: 'Browse Bars',
    description: 'Find drinks & venues near you',
    image: appScreenshots.browse,
    icon: <FaGlassCheers size={22} className="text-foreground-50" />,
  },
  {
    title: 'Send a Drink',
    description: 'Gift a drink to anyone, anywhere',
    image: appScreenshots.send,
    icon: <FaGift size={22} className="text-foreground-50" />,
  },
  {
    title: 'Track & Map',
    description: 'Follow your drink in real time',
    image: appScreenshots.track,
    icon: <FaMapMarkerAlt size={22} className="text-foreground-50" />,
  },
  {
    title: 'Chat & Connect',
    description: 'Message before you meet up',
    image: appScreenshots.chat,
    icon: <FaComment size={22} className="text-foreground-50" />,
  },
  {
    title: 'Live Presence',
    description: 'See friends at the bar now',
    image: appScreenshots.live,
    icon: <FaBroadcastTower size={22} className="text-foreground-50" />,
  },
];

export default function AppShowcaseSection() {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const obs = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            el.querySelectorAll('.showcase-animate').forEach((child, i) => {
              (child as HTMLElement).style.animationDelay = `${i * 0.12}s`;
              child.classList.add('animate-fade-in-up');
            });
            obs.unobserve(el);
          }
        });
      },
      { threshold: 0.1 }
    );
    obs.observe(el);
    return () => obs.disconnect();
  }, []);

  return (
    <section ref={ref} className="relative w-full py-24 md:py-32 bg-background-950 overflow-hidden">
      {/* Yellow accent line top */}
      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-primary-500/30 to-transparent" />

      <div className="w-full px-4 md:px-10 lg:px-16">
        {/* Header */}
        <div className="text-center max-w-2xl mx-auto mb-16">
          <p className="showcase-animate opacity-0 text-primary-500 text-xs font-bold tracking-[0.3em] uppercase mb-4">
            The App
          </p>
          <h2 className="showcase-animate opacity-0 text-3xl sm:text-4xl md:text-5xl font-black text-foreground-50 tracking-tight leading-tight">
            Designed for
            <br />
            <span className="text-primary-500">the night.</span>
          </h2>
        </div>

        <div className="showcase-animate opacity-0">
          <InteractiveSelector options={options} />
        </div>
      </div>
    </section>
  );
}